import App from "./App";
import PlanDetailsPage from "./components/Plan-detail/PlanDetailsPage";
import Brcapage from "./components/Plan-detail/Brcapage";
import smartFullBody from "./components/Plan-detail/smartFullBody";
import Franchise from "./Pages/Franchise";
// import Blog from "./components/Blog/Blog"   ;
import Search from "./Pages/SearchBar/Search";
import Giftcard from "./Pages/Giftcard/Giftcard";
import ImaginePatientDetails from "./components/Redcliffe-Imaging/ImagineBooking/PatientDetails";
import ImaginePatientAddress from "./components/Redcliffe-Imaging/ImagineBooking/PatientAddress";
import Adlp2 from "./Pages/packageDetailsPage/Adlp2";
import Adlp3 from "./Pages/packageDetailsPage/Adlp3.js";
import Lp2taboola from "./Pages/packageDetailsPage/lp2taboola";
import Adlp from "./Pages/packageDetailsPage/Adlp.js";
import ThyroidLp from "./Pages/LandingPages/ThyroidLp";
import HomePage from "./Pages/homePage/homePage";
import Samlp2 from "./Pages/LandingPages/Samlp2";
import AllPackages from "./Pages/AllPackages";
import ImagineQuery from "./components/Redcliffe-Imaging/ImagineQuery";
// import PackageDetailsPage from "./Pages/packageDetailsPage/PackageDetailsPageTwo";
import AboutPage from "./Pages/AboutUs";
import StaticLp from "./Pages/LandingPages/StaticLp";
import TermsOfUse from "./Pages/TermsOfUse";
import viewBooking from "./components/Bookingsuccess/Success";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import Corporate from "./Pages/Corporate";
import ContactUs from "./Pages/ContactUs";
import WhyUsComponent from "./Pages/homePage/Components/WhyUs";
// import Covid19 from "./Pages/Covid19/Covid19";
import PartnerWithUs from "./Pages/PartnerWithUs";
import PhoneLogin from "./components/Authorization/PhoneLogin";
import LoginNew from "./components/NewLogin/Login";
import PasswordChange from "./components/NewLogin/PasswordChange";
import NewSignUp from "./components/NewLogin/NewSignUp";
import Otpverification from "./components/Authorization/Otp_verification/Otp_verification";
// import ServiceDetailsPage from './Pages/ServiceDetailsPage'
import ErrorPage from "./Pages/ErrorPage";
// import RazorPay from "./Pages/RazorPay/RazorPay";
import Register from "./components/Authorization/Register";
import DashBoard from "./components/Dashboard/Dashboard";
// import Mobileview from './components/Mobile/Mobileview';
// import Mobile from './components/PackageDetails/Banner/Mobile';`
import CustomerDashboard from "./components/Dashboard/customer_dashboard/customer_dashboard.js";
import Newcovid from "./Pages/Covid19/Newcovid";
// import MyReport from "./components/Dashboard/customer_dashboard/Myreport";
import MyBookings from "./components/Dashboard/customer_dashboard/MyBookings";
import Errorforpackage from "./components/Plan-detail/Errorforpackage";
import Query from "./Pages/Query";
import Newlp from "./Pages/packageDetailsPage/Newlp";
import BlogCategory from "./Pages/homePage/Components/BlogCategory";
import Career from "./Pages/Career";
import DirectReport from "./components/DirectReport/DirectReport";
import AllNewPackages from "./Pages/packageDetailsPage/AllNewPackages";
import LpImageing from "./components/Redcliffe-Imaging/Homepage/LpImageing";
import LpImageingvl from "./components/Redcliffe-Imaging/Homepage/LpImageingvl";
import BlogDetails from "./components/Blog/BlogDetails";
import Imaging from "./components/Redcliffe-Imaging/Imaging";
import ImagingNew from "./components/Redcliffe-Imaging/ImagingNew";
import smsSuccess from "./Pages/SmsVerification/Success";
import smsCancel from "./Pages/SmsVerification/Cancel";
import Uploadprescription from "./Pages/Uploadprescription/Uploadprescription";
import smartplusfullbody from "./components/Plan-detail/smartplusfullbody";
import Advanceplusfullbody from "./components/Plan-detail/Advanceplusfullbody";
import Advancefullbody from "./components/Plan-detail/Advancefullbody";
import TopSelling from "./Pages/packageDetailsPage/TopSelling";
import NewAbout from "./Pages/NewAbout";
import lpSmartFullbody from "./Pages/packageDetailsPage/lpSmartFullbody";
import Unsubscribe from "./components/NewsLetter/Unsubscribe";
import lpSmartfullBodyCombo from "./Pages/packageDetailsPage/lpSmartfullBodyCombo";
import ImagineContactus from "./components/Redcliffe-Imaging/ImagineContactus";
// import Center from "./components/center/Center";
import CenterNew from "./components/center/CenterNew";

import lpSmartfullBodyCombo77 from "./Pages/packageDetailsPage/lpSmartfullBodyCombo77";
import NewPlanComponent from "./components/Plan-detail/NewPlanComponent";
import PlanAddress from "./components/Plan-detail/PlanAddress";
import planAddress2 from "./components/Plan-detail/planAddress2";
import PlanSlot from "./components/Plan-detail/PlanSlot";
import Lp from "./Pages/LandingPages/Lp";
import LpLanguage from "./Pages/LandingPages/LpLanguage";
import LpSmsEmail from "./Pages/LandingPages/LpSmsEmail";
import PatientTestimonial from "./Pages/patientTestimonial/PatientTestimonial";
import Diagnostic from "./components/Diagnostics/Diagnostic";
import LpDisplay from "./Pages/LandingPages/LpDisplay";
import Samlp from "./Pages/LandingPages/Samlp";
import Dashboard from "./components/New-Dashboard/Dashboard";
import Orders from "./components/New-Dashboard/Orders";
import Family_friends from "./components/New-Dashboard/Family_friends";
import Help_and_support from "./components/New-Dashboard/Help_and_support";
import Cart from "./components/Cart/Cart";
import Review from "./components/Cart/Review";
import PatientDetails from "./components/Cart/PatientDetails";
import NewContactUs from "./components/ContactUs/ContactUs";
import lpSmartFullbodyPro from "./Pages/packageDetailsPage/lpSmartFullbodyPro";
import lpSmartfullBodyCombo77pro from "./Pages/packageDetailsPage/lpSmartfullBodyCombo77pro";
import UserProfile from "./components/New-Dashboard/UserProfile";
import MyAddresses from "./components/New-Dashboard/MyAddresses";
import UploadLp from "./Pages/LandingPages/UploadLp";
import HomepageImaging from "./components/Redcliffe-Imaging/Homepage/HomepageImaging";
import OrderConfirmed from "./components/Cart/OrderConfirmed";
import NewHeader from "./components/NewHeader/NewHeader";
import BookedComponent from "./components/Redcliffe-Imaging/BookedComponent";
import ImagingDetail from "./components/Redcliffe-Imaging/ImagingDetail";
import ImagingPackage from "./components/Redcliffe-Imaging/ImagingPackage";
import Myredcash from "./components/New-Dashboard/Myredcash";
import Invoice from "./Pages/Invoice";
import ImagingCart from "./components/Redcliffe-Imaging/ImagingCart";
import ImagingPrescription from "./components/Redcliffe-Imaging/ImagingPrescription";
import ImagingPlanSlot from "./components/Redcliffe-Imaging/ImagingPlanSlot";
import LpRTPCR from "./Pages/packageDetailsPage/LpRTPCR.js";
import ImagingReview from "./components/Redcliffe-Imaging/ImagingReview";
import Lp7 from "./Pages/LandingPages/Lp7";
import NewImgContactUs from "./components/Redcliffe-Imaging/NewImgContactUs";
import MyPrescription from "./components/New-Dashboard/MyPrescription";
import OurDoctors from "./Pages/OurDoctors/OurDoctors";
import TestOtp from "./Pages/Test/TestOtp";
import Location from "./Pages/Location";
import LpNew from "./Pages/LandingPages/LpNew";
import LpGuts from "./Pages/LandingPages/LpGuts";
import SmartfullLp from "./Pages/LandingPages/SmartfullLp";
import DoctorConfirmation from "./Pages/DoctorConsultation";
import PaymentStatus from "./Pages/PaymentStatusPage";
import Feedback2 from "./Pages/NPSFeedback/Feedback2";
import Feedback from "./Pages/NPSFeedback";
import Bank from "./Pages/Bank/Bank";
// import Myhealth from "./Pages/Myhealth/Myhealth";
import ImagingSearch from "./Pages/ImagingSearch/ImagingSearch";


// import RedO from "./Pages/RedO/RedO";
// import DoctorListing from "./Pages/DoctorListing/DoctorListing";
import DLDetail from "./Pages/DoctorListing/DLDetail";
// import NewHeaderNext from "./Pages/NewHeaderNext";

const Routes = [
  {
    ...App,
    routes: [
      // {...BookedComponent,path:"/Imaging/booked",exact:true},
      // { ...RedO, path: "/redo", exact: true},
      // { component: NewHeaderNext, path: "/new-header-next", exact: true },
      { ...Feedback, path: "/feedback", exact: true },
      { ...Bank, path: "/bank", exact: true },
      // { ...Myhealth, path: "/myhealth", exact: true },
      { ...Feedback2, path: "/feedback2", exact: true },
      // { ...DoctorListing, path: "/dl", exact: true},
      { ...DLDetail, path: "/:cityslug/imaging/:slug", exact: true},
      {
        ...DoctorConfirmation,
        path: "/doctor_consultation/:slug",
        exact: true,
      },
      { ...PaymentStatus, path: "/paymentstatus", exact: true },
      { ...TestOtp, path: "/testing", exact: true },
      { ...Giftcard, path: "/gift-card", exact: true },
      // { ...CityWiseTest, path: "/test", exact: true },
      { ...Location, path: "/ltest", exact: true },
      { ...OurDoctors, path: "/ourdoctors", exact: true },
      {
        ...LpImageing,
        path: "/lp/Imaging-2/google/radiology-services",
        exact: true,
      },
      {
        ...LpImageing,
        path: "/lp/Imaging/google/radiology-services",
        exact: true,
      },
      {
        ...LpImageingvl,
        path: "/lp/Imaging/vl/radiology-services",
        exact: true,
      },
      { ...ThyroidLp, path: "/lp8/thyroid-test", exact: true },
      { ...SmartfullLp, path: "/lp8/smart-full-body-checkup", exact: true },

      // dashboard new
      { ...UserProfile, path: "/userprofile", exact: true },
      // My addresses
      { ...MyAddresses, path: "/myaddresses", exact: true },
      // My redcash
      { ...Myredcash, path: "/myredcash", exact: true },
      // ORDER CONFIRMED
      { ...OrderConfirmed, path: "/confirmed", exact: true },
      // New-Dashboard
      { ...Dashboard, path: "/userDashboard", exact: true },
      // { ...Family_friends, path: '/familyfriends', exact: true },
      //My Prescription
      { ...MyPrescription, path: "/myprescription", exact: true },

      { ...Help_and_support, path: "/helpandsupport", exact: true },

      {
        ...ImaginePatientDetails,
        path: "/imagine-patient-details",
        exact: true,
      },
      // { ...LpNew, path: "/lp7/smart-full-body-checkup", exact: true },
      { ...Lp7, path: "/lp7/:slug", exact: true },
      { ...LpNew, path: "/lp9/:slug", exact: true },
      { ...LpNew, path: "/lp9/fb/:slug", exact: true },
      { ...LpNew, path: "/lp9/sms/:slug", exact: true },
      { ...LpGuts, path: "/wellness/gut-microbiome-test", exact: true },

      {
        ...ImaginePatientAddress,
        path: "/imagine-patient-Address",
        exact: true,
      },
      {
        ...lpSmartfullBodyCombo77,
        path: "/affiliate/smart-full-body-checkup-combo",
        exact: true,
      },
      { ...Franchise, path: "/franchising-opportunities", exact: true },
      {
        ...lpSmartfullBodyCombo77,
        path: "/affiliate/smart-full-body-checkup-combo-offer",
        exact: true,
      },

      { ...PatientDetails, path: "/ps", exact: true },
      { ...NewContactUs, path: "/contact-us", exact: true },
      // { ...WhyUsComponent, path: "/why-us", exact: true },
      { ...Review, path: "/or", exact: true },
      { ...ImagingReview, path: "/imagine/or", exact: true },
      // { ...Dashboard, path: "/userdashboard", exact: true },
      //  { ...RazorPay, path: '/rpay', exact: true },
      { ...DashBoard, path: "/report", exact: true },
      { ...BlogCategory, path: "/blog", exact: true },
      { ...Orders, path: "/myOrders", exact: true },
      { ...Diagnostic, path: "/diagnostic", exact: true },
      { ...Cart, path: "/cart", exact: true },
      { ...ImagingCart, path: "/imaging/cart", exact: true },
      { ...Unsubscribe, exact: true, path: "/email/unsubscribe/:id" },
      // { ...Blog2, path: '/blog2', exact: true, },
      { ...HomepageImaging, path: "/mri-scan", exact: true },
      { ...MyBookings, path: "/mybookings", exact: true },
      { ...CustomerDashboard, path: "/customerdashboard", exact: true },
      { ...HomePage, path: "/", exact: true },
      { ...NewAbout, path: "/about-us", exact: true },
      { ...ContactUs, path: "/contact", exact: true },
      { ...PhoneLogin, path: "/login", exact: true },
      { ...LoginNew, path: "/loginNew", exact: true },
      { ...PasswordChange, path: "/passwordChange", exact: true },
      { ...NewSignUp, path: "/newSignUp", exact: true },
      { ...ImagineQuery, path: "/imagine-query", exact: true },
      { ...ImagineContactus, path: "/imagine-contact", exact: true },
      { ...NewImgContactUs, path: "/imaging/contact", exact: true },
      //PATIENT TESTIMONIAL
      { ...PatientTestimonial, path: "/patient-testimonials", exact: true },
      // { ...Covid19, path: "/covid-19", exact: true },
      // { ...NewPlanComponent, exact: true, path: "/:packagename" },
      { ...PlanAddress, exact: true, path: "/address" },

      { ...planAddress2, exact: true, path: "/address2" },
      { ...PlanSlot, exact: true, path: "/slot" },
      // { ...NewAbout, path: "/newAbout", exact: true },
      { ...TopSelling, path: "/top-selling", exact: true },
      { ...Newcovid, path: "/covid-19", exact: true },
      // { ...AllNewPackages, path: "/allpackages", exact: true },
      { ...TermsOfUse, path: "/terms-of-use", exact: true },
      { ...Otpverification, path: "/verifyotp", exact: true },
      { ...Register, path: "/register", exact: true },
      { ...PrivacyPolicy, path: "/privacy", exact: true },
      // { ...PartnerWithUs, path: "/franchising-opportunities", exact: true },
      // {...MobileAppRef,path: "/mobilee",exact: true},
      // { ...Blog,path: "/blog/:blogslug",exact: true},
      { ...Query, path: "/query", exact: true },
      { ...BlogDetails, path: "/blog/:blogslug", exact: true },
      // { ...Imaging, path: "/imaging", exact: true },
      { ...ImagingNew, path: "/imaging", exact: true },
      // { ...ImagingDetail, path: "/imaging-detail", exact: true },
      //Booking confirmation
      { ...LpRTPCR, path: "/lp2/rtpcr-900", exact: true },
      { ...LpRTPCR, path: "/lp2/rtpcr-950", exact: true },
      { ...LpRTPCR, path: "/lp2/rtpcr-500", exact: true },
      { ...LpRTPCR, path: "/lp2/rtpcr-400", exact: true },
      { ...LpRTPCR, path: "/lp2/rtpcr-750", exact: true },
      {
        ...AllNewPackages,
        path: "/health-checkup-packages",
        exact: true,
      },
      {
        ...ImagingPackage,
        path: "/imaging/health-checkup-packages-:citySlug",
        exact: true,
      },
      {
        ...ImagingPackage,
        path: "/imaging/health-checkup-packages",
        exact: true,
      },
      { ...UploadLp, path: "/lp4/:slug", exact: true },
      { ...smsSuccess, path: "/bco/:idSlug/", exact: true },
      { ...smsCancel, path: "/bcn/:idSlug/", exact: true },
      { ...viewBooking, path: "/bcv/:idSlug/", exact: true },
      //corporatepage
      { ...Corporate, exact: true, path: "/corporate-tieups" },
      { ...Career, exact: true, path: "/career" },
      // { ...DashBoard, path: "/customerdashboard", exact: true },
      {
        ...AllNewPackages,
        path: "/health-checkup-packages-:citySlug",
        exact: true,
      },
      { ...Brcapage, path: "/brca-gene-test", exact: true },
      { ...Lp, path: "/affiliate/:slug", exact: true },
      { ...Lp, path: "/affiliate/sms/:slug", exact: true },
      { ...Lp, path: "/lp/affiliate/sms/:slug", exact: true },
      { ...Lp, path: "/lp/affiliate/:slug", exact: true },
      {
        ...lpSmartFullbody,
        path: "/lp/sms/smart-full-body-checkup1",
        exact: true,
      },
      {
        ...lpSmartFullbodyPro,
        path: "/lp/sms/smart-full-body-checkup-pro",
      },
      {
        ...LpSmsEmail,
        path: "/lp/emailer/smart-full-body-checkup",
        exact: true,
      },

      {
        ...lpSmartfullBodyCombo,
        path: "/lp/sms/smart-full-body-checkup-combo-offer",
        exact: true,
      },
      {
        ...lpSmartfullBodyCombo77,
        path: "/lp/sms/smart-full-body-checkup-combo-offer-77-test",
        exact: true,
      },
      {
        ...lpSmartfullBodyCombo77pro,
        path: "/lp/sms/smart-full-body-checkup-combo-offer-77-pro",
        exact: true,
      },
      { ...Lp, path: "/la/sms/:slug", exact: true },
      { ...Samlp, path: "/lp/female-fertility-test", exact: true },
      { ...Samlp2, path: "/lp/female-fertility-test2", exact: true },
      // { ...LpNew, path: "/lp/fb/smart-full-body-checkup", exact: true },
      { ...StaticLp, path: "/lp/fb/smart-full-body-checkup", exact: true },
      { ...smartFullBody, path: "/news-letter", exact: true },
      // { ...LpNew, path: "/lp/prime-full-body-checkup", exact: true },
      { ...Lp, path: "/lp/:slug", exact: true },
      { ...LpLanguage, path: "/lp5/:slug", exact: true },
      { ...LpDisplay, path: "/lp-display/:slug", exact: true },
      { ...Lp, path: "/lp-taboola/:slug", exact: true },
      { ...Lp2taboola, path: "/lp2-taboola/:slug", exact: true },
      { ...Lp, path: "/lp/fb/:slug", exact: true },
      { ...Adlp, path: "/lp2/:slug", exact: true },
      { ...Adlp2, path: "/lp3/:slug", exact: true },
      { ...Adlp3, path: "/lp6/:slug", exact: true },
      { ...Adlp3, path: "/lp6/fb/:slug", exact: true },
      { ...Adlp3, path: "/lp6/paytm/:slug", exact: true },
      { ...Adlp3, path: "/lp6/ABS01/:slug", exact: true },
      { ...Adlp3, path: "/lp6/ABS02/:slug", exact: true },
      { ...Lp, path: "/lp/sms/:slug", exact: true },
      { ...Lp, path: "/lg/sms/:slug", exact: true },
      { ...Lp, path: "/la/sms/:slug", exact: true },
      { ...Lp, path: "/yd/sms/:slug", exact: true },
      { ...Lp, path: "/wd/sms/:slug", exact: true },
      { ...Imaging, path: "/ilp/", exact: true },

      { ...Imaging, path: "/ilp/fb/", exact: true },
      { ...Imaging, path: "/ilp/sms/", exact: true },
      { ...Errorforpackage, path: "/package/:anyslug", exact: true },
      { ...DirectReport, path: "/report/:reportslug", exact: true },
      // invoice
      { ...Invoice, path: "/invoice", exact: true },
      { ...ImagingPlanSlot, path: "/imaging/timeSlot", exact: true },
      // //center for page
      // { ...Center, path: "/lab-centre-network", exact: true },
      { ...CenterNew, path: "/lab-centre-network", exact: true },

      { ...Uploadprescription, path: "/uploadprescription", exact: true },
      {
        ...ImagingPrescription,
        path: "/imaging/uploadprescription",
        exact: true,
      },
      { ...ImagingSearch, path: "/imaging/search", exact: true },
      { ...PlanDetailsPage, path: "/:packagename", exact: true },
      { ...ImagingDetail, path: "/imaging/:packagename", exact: true },
      { ...ErrorPage },
    ],
  },
];

export default Routes;
